export interface ApiGetClaimCompareMatchRequest {
    source_text: string;
    source_patent: string;
    source_lang: string;
    target_type: string;
    file_type?: 'patent' | 'freetext';  // V2 扩展：文件类型，默认 'patent'（向后兼容）
}

export interface ApiGetClaimCompareMatchResponse {
    match_text: string[];
}

export const GetClaimCompareMatch = Symbol.for('GetClaimCompareMatch');

export interface GetClaimCompareMatch {
    getClaimCompareMatch(request: ApiGetClaimCompareMatchRequest): Promise<ApiGetClaimCompareMatchResponse>;
}
